<template>
  <div class="form1">
    <div class="story">
      <h2>编写故事剧本</h2>
      <br />
      <br />
      <div class="panel">
        <div class="panel_left">
          <el-form
            :model="form"
            label-width="auto"
            style="max-width: 600px"
            label-position="top"
            :rules="rules"
            ref="ruleForm"
            status-icon
          >
            <el-form-item label="故事标题" prop="storyTitle">
              <el-input v-model="form.storyTitle" size="large" />
            </el-form-item>
            <el-form-item label="故事图" prop="storyCover">
              <el-upload
                class="avatar-uploader"
                :action="UpdateApi"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                :limit="1"
                :file-list="fileList"
                :disabled="allowUpload"
              >
                <el-image
                  :src="form.storyCover"
                  v-if="form.storyCover"
                  class="avatar"
                  alt=""
                  :fit="'contain'"
                >
                  <template #error>
                    <div class="image-slot">
                      <el-icon><icon-picture /></el-icon>
                    </div>
                  </template>
                </el-image>
                <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
              </el-upload>
            </el-form-item>
            <el-form-item v-if="allowUpload">
              <el-button type="warning" @click="clearImage">{{
                $t("settings.clearImg")
              }}</el-button>
            </el-form-item>
            <el-form-item label="故事内容" prop="storyDesc">
              <el-input
                v-model="form.storyDesc"
                type="textarea"
                size="large"
                rows="10"
                show-word-limit
                maxlength="1000"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="panel_right">
          <p class="title">App示意图</p>
          <div class="example">
            <img :src="form.storyCover" alt="" />
            <p>{{ form.storyTitle }}</p>
            <p style="white-space: pre-wrap">
              {{ form.storyDesc }}
            </p>
            <p>
              <span>继续</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  watch,
  onMounted,
  onUnmounted,
  reactive,
} from "vue";
import { Plus } from "@element-plus/icons-vue";
import { ElNotification, FormRules, UploadProps } from "element-plus";
import { toRaw } from "@vue/reactivity";
const validateNotEmpty = (rule: any, value: string, callback: any) => {
  if (value.trim() === "") {
    callback(new Error(rule.message));
  } else {
    callback();
  }
};
interface Data {
  title: string;
  counter: number;
  message: string;
  data: any;
  loading: boolean;
  error: string;
  boxRef: HTMLElement | null;
}

export default defineComponent({
  name: "App",
  components: { Plus },
  props: ["dataForm"],
  data(): any {
    return {
      form: {
        storyCover: "",
        storyDesc: "",
        storyTitle: "",
      },
      fileList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      rules: reactive<FormRules>({
        storyTitle: [
          {
            required: true,
            message: "故事标题不能为空",
            trigger: "blur",
            validator: validateNotEmpty,
          },
        ],
        storyCover: [
          {
            required: true,
            message: "故事封面不能为空",
            trigger: "blur",
            validator: validateNotEmpty,
          },
        ],
        storyDesc: [
          {
            required: true,
            message: "故事描述不能为空",
            trigger: "blur",
            validator: validateNotEmpty,
          },
        ],
      }),
    };
  },
  computed: {
    doubledCounter(): number {
      return this.counter * 2;
    },
    allowUpload() {
      return this.form.storyCover !== "" && this.form.storyCover !== null;
    },
    UpdateApi() {
      return process.env.VUE_APP_Update_API;
    },
  },
  watch: {
    counter(newVal: number, oldVal: number) {
      console.log(`Counter changed from ${oldVal} to ${newVal}`);
    },
    message(newVal: string, oldVal: string) {
      console.log(`Message changed from "${oldVal}" to "${newVal}"`);
    },
    dataForm: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.updateForm(newVal);
        }
      },
    },
  },
  mounted() {
    // setTimeout(() => {
    //   this.form.storyCover = this.dataForm.storyCover;
    //   this.form.storyDesc = this.dataForm.storyDesc;
    //   this.form.storyTitle = this.dataForm.storyTitle;
    // }, 200);
  },
  methods: {
    updateForm(dataForm) {
      this.form.storyCover = dataForm.storyCover;
      this.form.storyDesc = dataForm.storyDesc;
      this.form.storyTitle = dataForm.storyTitle;
    },
    handleSave() {
      const { updateTime, ...formWithoutUpdateTime } = this.form;

      console.log(formWithoutUpdateTime);
      this.$store
        .dispatch("game/updateGame", { gameBean: formWithoutUpdateTime })
        .then((res: any) => {})
        .catch(() => {});
    },
    fetchGameList(gameLevelId: string) {
      this.$store
        .dispatch("game/getGameLevelList", { gameLevelId: gameLevelId })
        .then((res: any) => {
          console.log(res);
        })
        .catch((err: any) => {
          console.log(err);
        });
    },
    beforeAvatarUpload(file: File) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        ElNotification.warning({
          message: "请上传png/jpg",
          offset: 100,
          duration: 3000,
        });
        return false;
      }
      if (!isLt2M) {
        ElNotification.warning({
          message: "图片必须小于5m",
          offset: 100,
          duration: 3000,
        });
        return false;
      }

      // Display uploaded avatar
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.form.storyCover = reader.result as string;
      };

      return true;
    },
    handleAvatarSuccess(response: any) {
      this.form.storyCover = response.data.returnFileUrl;
    },
    handlePictureCardPreview(uploadFile: any): UploadProps["onPreview"] | void {
      this.dialogImageUrl = uploadFile.url!;
      this.dialogVisible = true;
    },
    handleRemove(
      uploadFile: any,
      uploadFiles: any
    ): UploadProps["onRemove"] | void {
      console.log(uploadFile, uploadFiles);
    },
    clearImage() {
      this.form.storyCover = "";
      this.fileList = [];
    },
  },
});
</script>

<style lang="less" scoped>
.panel {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  &_left {
    width: 50%;
  }

  &_right {
    width: 50%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;

    .title {
      margin-bottom: 20px;
      font-size: 1vw;
    }

    .example {
      width: 300px;
      height: 500px;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
      border-radius: 10px;
      position: relative;

      img {
        width: 100%;
        height: 50%;
        object-fit: contain;
      }

      p {
        &:nth-child(2) {
          width: 100%;
          height: auto;
          text-align: center;
          box-sizing: border-box;
          padding: 10px;
        }

        &:nth-child(3) {
          width: 100%;
          height: 140px;
          overflow-y: scroll;
          font-family: 新宋体;
          box-sizing: border-box;
          padding: 10px;
          text-align: left;
        }

        &:nth-child(4) {
          position: absolute;
          bottom: 20px;
          left: 100px;
          width: 100px;
          height: 40px;
          background: rgb(45, 168, 224);
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
        }
      }
    }
  }
}

.box {
  width: 100px;
  height: 100px;
}

.avatar-uploader .avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
}

、.avatar-uploader .avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.avatar-uploader {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

.avatar-uploader:hover {
  border-color: var(--el-color-primary);
}
</style>
